import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom'
import { themes } from './themes.js'

// pages
import { Home } from './pages/home.jsx'
import { Profile } from './pages/profile.jsx'
import { Login } from './pages/login.jsx'
import { Video } from './pages/video.jsx'
import { Invite } from './pages/invite.jsx'
import { ErrorPage } from './pages/error.jsx'
import { PrivacyPolicy } from './pages/privacy-policy.jsx'
import { Create } from './pages/create.jsx'
import { Team } from './pages/team.jsx'
import { CreateTeam } from './pages/create-team.jsx'

// components
import { Popup } from './cmps/popup/popup.jsx'
import { UpperPopup } from './cmps/upper-popup.jsx'
import { Preview } from './cmps/mock/preview.jsx'
import { Header } from './cmps/header.jsx'

// services
import { userService } from './services/user.js'

// actions
import { setUpperPopup, setSearch } from './store/reducers/general.js'
import { login } from './store/reducers/user.js'

function App() {
  const dispatch = useDispatch()
  const user = useSelector(state => state.user)
  const { themeName } = useSelector(state => state.general)

  useEffect(() => {
    applyTheme()
    loadUser()
    dispatch(setSearch(''))
  }, [])

  const loadUser = async () => {
    try {
      if (!user._id) return
      const loadedUser = await userService.getUser()
      dispatch(login(loadedUser))
    }
    catch (err) {
      dispatch(setUpperPopup('errorServer'))
    }
  }

  const applyTheme = () => {
    const t = themes[themeName] || themes.youtube
    const root = document.documentElement
    Object.entries(t).forEach(([key, value]) => {
      root.style.setProperty(`--${key}`, value)
    })
  }

  const router = createBrowserRouter([
    {
      path: '/',
      element: <div>
        <Header />
        <div className='main'>
          <Outlet />
        </div>
        <Preview />
        <Popup />
        <UpperPopup />
      </div>,
      errorElement: <ErrorPage />,
      children: [
        { index: true, element: <Home /> },
        { path: 'invite/:teamId/:channelName/:imageId/:roles/:recieverId', element: <Invite /> },
        { path: 'profile', element: <Profile /> },
        { path: 'new-team', element: <CreateTeam /> },
        { path: 'team', element: <Team /> },
        { path: 'login', element: <Login /> },
        { path: 'video/:id', element: <Video /> },
        { path: 'privacy-policy', element: <PrivacyPolicy /> },
        { path: 'create', element: <Create /> },
        { path: '/', element: <Home /> },
      ],
    },
  ])

  return <RouterProvider router={router} />
}

export default App
